import analytics from 'utils/analytics'

const TOKEN_KEY = 'token'
const TOKEN_REFRESH_KEY = 'token-refresh'
const USER_KEY = 'user'

const parseJwt = (token: string) => {
  try {
    return JSON.parse(atob(token.split('.')[1]))
  } catch (e) {
    return {}
  }
}

export const setUser = (token: string) => {
  const user = parseJwt(token)
  analytics.setUser(user)
  localStorage.setItem(USER_KEY, JSON.stringify(user))
}
export const getUser = () => {
  const user =
    USER_KEY in localStorage
      ? JSON.parse(localStorage.getItem(USER_KEY) || '')
      : null
  if (!user || !Object.keys(user).length) return null
  return user
}

export const setToken = (token: string) => {
  const httpClient = require('utils/httpClient').default
  setUser(token)
  localStorage.setItem(TOKEN_KEY, token)
  httpClient.defaults.headers.common['Authorization'] = `JWT ${token}`
}
export const getToken = (): string | null => localStorage.getItem(TOKEN_KEY)

export const setRefreshToken = (refreshToken: string) =>
  localStorage.setItem(TOKEN_REFRESH_KEY, refreshToken)

export const getRefreshToken = (): string | null =>
  localStorage.getItem(TOKEN_REFRESH_KEY)

export const obtainToken = async (username: string, password: string) => {
  const httpClient = require('utils/httpClient').default
  const { data } = await httpClient.post('/api/auth/token/', {
    username,
    password,
  })
  setToken(data.access)
  setRefreshToken(data.refresh)
  return {
    accessToken: data.access,
    refreshToken: data.refresh,
    roles: [],
    ...parseJwt(data.access),
  }
}

export const refreshToken = async (): Promise<string> => {
  const httpClient = require('utils/httpClient').default
  const { data } = await httpClient.post('/api/auth/token/refresh/', {
    refresh: getRefreshToken(),
  })
  setToken(data.access)
  return data.access
}

export const logout = () => {
  const storageKeys = [TOKEN_KEY, TOKEN_REFRESH_KEY, USER_KEY]
  storageKeys.forEach((key) => {
    localStorage.removeItem(key)
  })
  window.location.replace('/login')
}
